import { useState } from 'react';
import NavButtons from '../components/NavButtons';
import ContentBlocks from '../components/ContentBlocks';

const normalize = (s) => s.toLowerCase().replace(/[\s.,!?'"]+/g, '');
const isMatch = (input, correctAnswers) =>
  correctAnswers.some((a) => normalize(input) === normalize(a));

function TriviaScreen({ heading, blocks, questions, finalQuestion, onBack, onNext, showBack = true }) {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [input, setInput] = useState('');

  const isFinalStep = step === questions.length;
  const currentQuestion = isFinalStep ? finalQuestion : questions[step];
  const canAdvance = isMatch(input, currentQuestion.correctAnswers);

  function handleNext() {
    if (isFinalStep) {
      onNext();
    } else {
      setAnswers((prev) => [...prev, input]);
      setInput('');
      setStep((s) => s + 1);
    }
  }

  return (
    <div className="screen">
      <div className="screen-content">
        {heading && <h1 className="screen-title">{heading}</h1>}
        <ContentBlocks blocks={blocks} />

        {!isFinalStep && (
          <p className="trivia-progress">Question {step + 1} of {questions.length}</p>
        )}

        {isFinalStep && (
          <div className="trivia-summary">
            {questions.map((q, i) => (
              <div key={i} className="trivia-summary-item">
                <span className="trivia-summary-label">{q.label}</span>
                <span className="trivia-summary-answer">{answers[i]}</span>
              </div>
            ))}
          </div>
        )}

        <p className="puzzle-question">{currentQuestion.question}</p>
        <input
          type="text"
          className="form-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Your answer..."
          autoComplete="off"
        />
      </div>
      <NavButtons
        onBack={onBack}
        onNext={handleNext}
        showBack={showBack && step === 0}
        nextDisabled={!canAdvance}
      />
    </div>
  );
}

export default TriviaScreen;
